export default __webpack_public_path__ + "static/img6AR-415518712947f0f0c3e23e2f81672a2d.png";